import { Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-popup-tutorial',
  templateUrl: './popup-tutorial.component.html',
  styleUrl: './popup-tutorial.component.scss'
})
export class PopupTutorialComponent {
@Input() display: boolean = false;
siteUrl: string = GlobalConstants.siteUrl

getDialogStyle(): any {
    if (window.innerWidth <= 768) { // You can adjust this breakpoint
      return { width: '100vw', top: 'auto', left: '0' };
    } else {
      return { width: '75vw' };
    }
  }

}
